import React, { FunctionComponent, useMemo, useState } from 'react';
import { useStore } from 'effector-react';
import spamComments, { getList } from '@stores/spamComments';
import { Spin, Pagination, Empty } from 'antd';
import css from './SpamCommentsList.module.less';
import SpamCommentCard from '@components/SpamCommentCard';
import { pageSizeOptions } from '@constants/pagination';
import { nanoid } from 'nanoid';
import UserCommentCard from '@components/UserCommentCard';

interface SpamCommentsListProps {}

const SpamCommentsList: FunctionComponent<SpamCommentsListProps> = () => {
  const { list, pagination, preloaders, filters } = useStore(spamComments);

  const [paginationKey, setPaginationKey] = useState(nanoid());

  const paginationChange = (newCurrent: number, pageSize?: number) => {
    const notMatchedComments = list.filter((c) => {
      if (!filters.needChecked) return !!c.isChecked;
      return false;
    });
    const isForward = newCurrent > (pagination.current || 0);

    let current = newCurrent;
    if (notMatchedComments.length && isForward) {
      current = newCurrent - 1;
      setPaginationKey(nanoid());
    }
    localStorage.setItem('spamCommentsPageSize', `${pageSize}`);
    getList({ pagination: { current, pageSize } });
  };

  const isListLoading = useMemo(() => {
    const { getList, getById } = preloaders;
    return !!(getList || getById);
  }, [preloaders]);

  if (!list.length && !isListLoading) {
    return <Empty />;
  }

  return (
    <div>
      <div className={css.paginationContainer}>
        <Pagination
          {...pagination}
          key={paginationKey}
          onChange={paginationChange}
          showQuickJumper
          showSizeChanger
          pageSizeOptions={pageSizeOptions}
        />
      </div>
      <Spin spinning={isListLoading}>
        <div className={css.root}>
          {list.map((comment) => (
            <SpamCommentCard
              key={comment.id}
              comment={comment}
            />
          ))}
        </div>
      </Spin>
      <div className={css.paginationContainer}>
        <Pagination
          {...pagination}
          key={paginationKey}
          onChange={paginationChange}
          showQuickJumper
          showSizeChanger
          pageSizeOptions={pageSizeOptions}
        />
      </div>
    </div>
  );
};

export default SpamCommentsList;
